import React, { useEffect } from 'react';
import { useNavigate, useSearchParams} from "react-router-dom";

const SelectShop = () => {
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();

    useEffect(() => {
        const shopDomain = searchParams.get('d');
        if(shopDomain) {
            localStorage.setItem('selectedDomain', shopDomain);
            navigate("/");
            window.location.reload();
        }
    }, []);

    return null;
}

export default SelectShop;
